import {isHdAccessActive} from './ViewLand/Images/imageTypeUtils'

export const HD_ACCESS_CHECKING = 'checking'
export const HD_ACCESS_ACTIVE = 'active'
export const HD_ACCESS_INACTIVE = 'inactive'
export const HD_ACCESS_ERROR = 'error'

export const PLANET_HD_VISUALIZATION_ACCESS_PARAMS = {
  operation: 'image_hd',
  image_type: 'rgb_hd',
}

export const resolveHdAccessCheck = (response) => {
  if (response?.ok) {
    return isHdAccessActive(response.data) ? HD_ACCESS_ACTIVE : HD_ACCESS_INACTIVE
  }

  if (response?.error_type === 'not_found') {
    return HD_ACCESS_INACTIVE
  }

  return HD_ACCESS_ERROR
}

export const needsPlanetHdConfirmation = (status) => status === HD_ACCESS_ACTIVE
